import Y from "../../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import s from "../../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import { isDOM as Yv } from "../../../../rc-util/es/Dom/findDOMNode.mjs";
import sv from "../../../../rc-util/es/Dom/isVisible.mjs";
import iv from "../../../../rc-util/es/hooks/useEvent.mjs";
import Xr from "../../../../rc-util/es/hooks/useLayoutEffect.mjs";
import * as t from "react";
import { collectScroller as ov, getWin as Pv, getVisibleArea as Yr, toNum as sr } from "../util.mjs";
function ir(r) {
  var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, y = "".concat(M), w = y.match(/^(.*)\%$/);
  return w ? r * (parseFloat(w[1]) / 100) : parseFloat(y);
}
function or(r, M) {
  var y = M || [], w = s(y, 2), C = w[0], q = w[1];
  return [ir(r.width, C), ir(r.height, q)];
}
function Pr() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [r[0], r[1]];
}
function B(r, M) {
  var y = M[0], w = M[1], C, q;
  return y === "t" ? q = r.y : y === "b" ? q = r.y + r.height : q = r.y + r.height / 2, w === "l" ? C = r.x : w === "r" ? C = r.x + r.width : C = r.x + r.width / 2, {
    x: C,
    y: q
  };
}
function J(r, M) {
  var y = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return r.map(function(w, C) {
    return C === M ? y[w] || "c" : w;
  }).join("");
}
function ev(r, M, y, w, C, q, e) {
  var gr = t.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: C[w] || {}
  }), hr = s(gr, 2), z = hr[0], lr = hr[1], p = t.useRef(0), Mr = t.useMemo(function() {
    return M ? ov(M) : [];
  }, [M]), d = t.useRef({}), Rr = function() {
    d.current = {};
  };
  r || Rr();
  var xr = iv(function() {
    if (M && y && r) {
      let U = function(Er, X) {
        var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : a, _r = u.x + Er, Ir = u.y + X, Nv = _r + k, Vv = Ir + f, Ev = Math.max(_r, O.left), _v = Math.max(Ir, O.top), Iv = Math.min(Nv, O.right), Xv = Math.min(Vv, O.bottom);
        return Math.max(0, (Iv - Ev) * (Xv - _v));
      }, Vr = function() {
        b = u.y + l, A = b + f, m = u.x + h, n = m + k;
      };
      var F = M, L = F.style.left, nr = F.style.top, Or = F.ownerDocument, tr = Pv(F), Z = Y(Y({}, C[w]), q);
      F.style.left = "0", F.style.top = "0";
      var v;
      if (Array.isArray(y))
        v = {
          x: y[0],
          y: y[1],
          width: 0,
          height: 0
        };
      else {
        var i = y.getBoundingClientRect();
        v = {
          x: i.x,
          y: i.y,
          width: i.width,
          height: i.height
        };
      }
      var u = F.getBoundingClientRect(), dr = tr.getComputedStyle(F), er = dr.width, pr = dr.height, j = Or.documentElement, rv = j.clientWidth, vv = j.clientHeight, av = j.scrollWidth, yv = j.scrollHeight, Fr = j.scrollTop, ur = j.scrollLeft, f = u.height, k = u.width, S = v.height, T = v.width, hv = {
        left: 0,
        top: 0,
        right: rv,
        bottom: vv
      }, lv = {
        left: -ur,
        top: -Fr,
        right: av - ur,
        bottom: yv - Fr
      }, W = Z.htmlRegion, Cr = "visible", Dr = "visibleFirst";
      W !== "scroll" && W !== Dr && (W = Cr);
      var H = W === Dr, Mv = Yr(lv, Mr), K = Yr(hv, Mr), a = W === Cr ? K : Mv, o = H ? K : a;
      F.style.left = L, F.style.top = nr;
      var P = sr(Math.round(k / parseFloat(er) * 1e3) / 1e3), g = sr(Math.round(f / parseFloat(pr) * 1e3) / 1e3);
      if (P === 0 || g === 0 || Yv(y) && !sv(y))
        return;
      var wv = Z.offset, dv = Z.targetOffset, Fv = or(u, wv), Ur = s(Fv, 2), rr = Ur[0], vr = Ur[1], uv = or(v, dv), qr = s(uv, 2), Cv = qr[0], Dv = qr[1];
      v.x -= Cv, v.y -= Dv;
      var Uv = Z.points || [], zr = s(Uv, 2), qv = zr[0], zv = zr[1], Q = Pr(zv), D = Pr(qv), Gr = B(v, Q), Jr = B(u, D), $ = Y({}, Z), h = Gr.x - Jr.x + rr, l = Gr.y - Jr.y + vr, G = U(h, l), R = U(h, l, K), Kr = B(v, ["t", "l"]), Qr = B(u, ["t", "l"]), Zr = B(v, ["b", "r"]), jr = B(u, ["b", "r"]), x = Z.overflow || {}, Gv = x.adjustX, Jv = x.adjustY, fr = x.shiftX, kr = x.shiftY, $r = function(X) {
        return typeof X == "boolean" ? X : X >= 0;
      }, b, A, m, n;
      Vr();
      var Br = $r(Jv), Lr = D[0] === Q[0];
      if (Br && D[0] === "t" && (A > o.bottom || d.current.bt)) {
        var c = l;
        Lr ? c -= f - S : c = Kr.y - jr.y - vr;
        var Sr = U(h, c), Kv = U(h, c, K);
        // Of course use larger one
        Sr > G || Sr === G && (!H || // Choose recommend one
        Kv >= R) ? (d.current.bt = !0, l = c, $.points = [J(D, 0), J(Q, 0)]) : d.current.bt = !1;
      }
      if (Br && D[0] === "b" && (b < o.top || d.current.tb)) {
        var N = l;
        Lr ? N += f - S : N = Zr.y - Qr.y - vr;
        var Tr = U(h, N), Qv = U(h, N, K);
        // Of course use larger one
        Tr > G || Tr === G && (!H || // Choose recommend one
        Qv >= R) ? (d.current.tb = !0, l = N, $.points = [J(D, 0), J(Q, 0)]) : d.current.tb = !1;
      }
      var Wr = $r(Gv), Hr = D[1] === Q[1];
      if (Wr && D[1] === "l" && (n > o.right || d.current.rl)) {
        var V = h;
        Hr ? V -= k - T : V = Kr.x - jr.x - rr;
        var br = U(V, l), Zv = U(V, l, K);
        // Of course use larger one
        br > G || br === G && (!H || // Choose recommend one
        Zv >= R) ? (d.current.rl = !0, h = V, $.points = [J(D, 1), J(Q, 1)]) : d.current.rl = !1;
      }
      if (Wr && D[1] === "r" && (m < o.left || d.current.lr)) {
        var E = h;
        Hr ? E += k - T : E = Zr.x - Qr.x - rr;
        var mr = U(E, l), jv = U(E, l, K);
        // Of course use larger one
        mr > G || mr === G && (!H || // Choose recommend one
        jv >= R) ? (d.current.lr = !0, h = E, $.points = [J(D, 1), J(Q, 1)]) : d.current.lr = !1;
      }
      Vr();
      var _ = fr === !0 ? 0 : fr;
      typeof _ == "number" && (m < a.left && (h -= m - a.left, v.x + T < a.left + _ && (h += v.x - a.left + T - _)), n > a.right && (h -= n - a.right, v.x > a.right - _ && (h += v.x - a.right + _)));
      var I = kr === !0 ? 0 : kr;
      typeof I == "number" && (b < a.top && (l -= b - a.top, v.y + S < a.top + I && (l += v.y - a.top + S - I)), A > a.bottom && (l -= A - a.bottom, v.y > a.bottom - I && (l += v.y - a.bottom + I)));
      var ar = u.x + h, fv = ar + k, yr = u.y + l, kv = yr + f, cr = v.x, $v = cr + T, Nr = v.y, Bv = Nr + S, Lv = Math.max(ar, cr), Sv = Math.min(fv, $v), Tv = (Lv + Sv) / 2, Wv = Tv - ar, Hv = Math.max(yr, Nr), bv = Math.min(kv, Bv), mv = (Hv + bv) / 2, cv = mv - yr;
      e == null || e(M, $), lr({
        ready: !0,
        offsetX: h / P,
        offsetY: l / g,
        arrowX: Wv / P,
        arrowY: cv / g,
        scaleX: P,
        scaleY: g,
        align: $
      });
    }
  }), Ar = function() {
    p.current += 1;
    var L = p.current;
    Promise.resolve().then(function() {
      p.current === L && xr();
    });
  }, wr = function() {
    lr(function(L) {
      return Y(Y({}, L), {}, {
        ready: !1
      });
    });
  };
  return Xr(wr, [w]), Xr(function() {
    r || wr();
  }, [r]), [z.ready, z.offsetX, z.offsetY, z.arrowX, z.arrowY, z.scaleX, z.scaleY, z.align, Ar];
}
export {
  ev as default
};
//# sourceMappingURL=useAlign.mjs.map
